module.exports = __webpack_public_path__ + "img/levelnext-poster.51457654.png";